// extracted by mini-css-extract-plugin
module.exports = {"alertInfo":"index_alertInfo__2Or_V","alertWrap":"index_alertWrap__6i5t7","alertIcon":"index_alertIcon__2K7Ly","alertText":"index_alertText__MP3cq"};